import React from 'react';
import DataGridPremium from '../../../DataGridPremium/DataGridPremium';
import { DataGridExportButton } from '@clatter/ui';

export const AssetUsageListView = ({
  columns,
  isLoading,
  reportData,
  defaultSortField,
  listViewTableName,
  listViewExportName,
}) => {
  return (
    <DataGridPremium
      loading={isLoading}
      getRowId={(row) => row._id}
      name={listViewTableName}
      renderCustomToolbar={() => <DataGridExportButton exportFileName={listViewExportName} />}
      rows={reportData}
      columns={columns}
      exportFileName={listViewExportName}
      defaultSortField={defaultSortField}
    />
  );
};
